module.exports = __webpack_public_path__ + "img/user08.cbc93575.png";